// Dependencies.
import moment from 'moment-timezone'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import { useEffect, useContext, useState } from 'react'
import { useRouter } from 'next/router'

import { UserContext } from '../../../context'
import { icons, tooltipHeader, tooltipContent } from '../../../utils'

const Div = styled.div`
  .globeImg {
    width: 14px;
    height: 14px;
    margin-left: 5px;
    vertical-align: middle;
  }

  .tooltip {
    width: 245px;
    max-width: 100%;
  }
`

// Props.
interface Props {
  globeColor?: string
  className?: string
}

// Date And Time.
export const TimezoneGlobe: React.FC<Props> = (props) => {
  const { pathname } = useRouter()

  if (!pathname.includes('/events/')) return null

  return <TimezoneGlobeInner {...props} />
}

export const TimezoneGlobeInner: React.FC<Props> = (props) => {
  // Props.
  const { globeColor, className } = props

  const { timezones, retrieveTimezones, currentUser } = useContext(UserContext)
  const [tz, setTZ] = useState('')

  const reCalculateTime = () => {
    let calculatedTZ = ''
    if (currentUser && currentUser.time_zone) {
      calculatedTZ = currentUser.time_zone
    } else {
      calculatedTZ = moment.tz.guess()
    }
    const offset = moment.tz(calculatedTZ).format('Z')
    if (timezones) {
      const timezoneName = timezones.find((t) => t.name === calculatedTZ)
      const tooltipHeader = timezoneName
        ? `(GMT ${offset}) ${timezoneName.display}`
        : `(GMT ${offset})`
      setTZ(tooltipHeader)
    }
  }

  const getToolTip = () => {
    const header = tooltipHeader(tz)
    if (currentUser) {
      const tooltip = tooltipContent(
        'To update your time zone please go to your account settings page.',
      )
      return `${header}${tooltip}`
    } else {
      return header
    }
  }

  useEffect(() => {
    if (!timezones) {
      retrieveTimezones()
    }
    reCalculateTime()
  }, [])

  useEffect(() => {
    reCalculateTime()
  }, [currentUser, timezones])

  // ..
  return (
    <Div className={className}>
      {globeColor && globeColor === 'black' && (
        <img
          className="globeImg"
          src={icons.blackGlobe}
          data-tip={getToolTip()}
          data-html={true}></img>
      )}
      {(!globeColor || globeColor === 'purple') && (
        <img
          className="globeImg"
          src={icons.purpleGlobe}
          data-tip={getToolTip()}
          data-html={true}></img>
      )}
      <ReactTooltip className="tooltip" />
    </Div>
  )
}
